"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var DeveloperComponent_module_css_1 = __importDefault(require("./DeveloperComponent.module.css"));
var react_i18next_1 = require("react-i18next");
var DeveloperToolbar = function (_a) {
    var tabs = _a.tabs, activeTab = _a.activeTab, onTabChange = _a.onTabChange;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("div", { className: DeveloperComponent_module_css_1.default["toolbar-container"] }, tabs.map(function (tab) { return (react_1.default.createElement("button", { key: tab.name, className: "".concat(DeveloperComponent_module_css_1.default["toolbar-tab"], " ").concat(activeTab === tab.name ? DeveloperComponent_module_css_1.default.active : ""), onClick: function () { return onTabChange(tab.name); }, title: t(tab.name), "data-cy": tab.dataCy },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: tab.icon }),
        " ",
        t(tab.name))); })));
};
exports.default = DeveloperToolbar;
